
import Footer from './Footer'
import { Col, Container, Row } from 'react-bootstrap'
import aboutimg from '../Assets/images/about.svg'

function About() {
  return (
    <>
    <div className='container'>
      <div className="container">

     <Container style={{ padding: "60px 0 0" }} className='sub-page'>
        <h1 className="fw-bold text-center">About Us</h1>
        <div className='mt-4'>
            <Row className='d-flex align-items-center about-section'>
              <Col lg={6} md={12} sm={12}>
              <h3 className='fw-bold'>Who We Are?</h3>
              <p className="mt-3">
              Banksstatements.com is an independent educational website focused on improving financial and banking awareness. We are a small team of content researchers and writers who are passionate about simplifying banking concepts for everyday users.
              </p>
              <p>We understand that banking terminology, account statements, digital banking systems, and financial procedures can often feel overwhelming. Our goal is to make these topics easier to understand by presenting information in a clear, structured, and user friendly manner.</p>
              <p>We do not represent or work with any bank or financial institution. All information published on this website is created independently and intended solely for educational purposes.</p>
              </Col>
              <Col lg={6} md={12} sm={12} className='d-flex  about-img'>
              <img src={aboutimg} alt="" style={{ height: "330px" }} />
              </Col>
            </Row>
        </div>
       <div className='mt-5'>
        <h3 className='fw-bold'>Why We Created This Platform</h3>
        <p className='mt-3'>Many users struggle to understand basic banking documents, account types, and financial processes due to complicated language and unclear explanations. We created BankStatements.com to bridge this knowledge gap.</p>
        <div className='about'>
        <p>Our platform focuses on:</p>
        <ul className='pl-5 d-flex flex-column gap-1'>
          <li>Explaining banking concepts in simple language</li>
          <li>Helping users understand financial terms and processes</li>
          <li>Providing educational insights into digital and traditional banking</li>
          <li>Promoting financial awareness and responsible money management</li>
        </ul>
        </div>
        <div>
          <p>We believe that access to clear and reliable financial information helps users make better decisions and avoid common misunderstandings related to banking.</p>
        </div>
       </div>

       <div className='mt-5 about'>
        <h3  className='fw-bold'>Why Choose Us?</h3>
        <p className='mt-3'>There are many sources of financial information online, but we aim to stand out by focusing on clarity, transparency, and user trust.</p>
        <p>Here’s what makes us different:</p>
         <ul className='pl-5 d-flex flex-column gap-1'>
          <li><b>Educational Focus –</b>Our content is designed for learning, not for selling products or services.</li>
          <li><b>Simple Language –</b>We avoid complex jargon and explain concepts in a way that is easy to understand.</li>
          <li><b>Independent Platform –</b>We are not affiliated with banks or financial institutions, ensuring unbiased information.</li>
          <li><b>User First Approach –</b>Content is written keeping everyday users in mind, including students, professionals, and beginners.</li>
          <li><b>Regular Updates –</b>We review and update our content to keep information relevant and accurate.</li>
        </ul>
       </div>

       <div className='mt-5'>
        <h3 className='fw-bold'>Our Content Approach</h3>
        <p className='mt-3'>All articles and pages on BankStatements.com are written after careful research and are structured to provide practical understanding rather than theoretical explanations. We focus on accuracy, readability, and transparency.</p>
        <p>Wherever applicable, we encourage users to verify information directly with official banking sources or financial professionals for critical decisions.</p>
       </div>
     
            
    </Container>
    </div>
    </div>
    <Footer />
    </>
  )
}

export default About
